import React from 'react';
// This context is used to pass to components rendered in Chat
// the information if they are at the moment being *visibly* rendered in the dome
// E.g. the MiniBoard and Board share redux state and changes in the board
// can mess up the *invisible* but in DOM MiniBoard
// due to the performance optimization, that the Chat always exists in the DOM
export const ChatActiveContext = React.createContext(true);
